const zh = {
  meta: {
    home: { title: "詹妮弗·洛佩兹传记与时间线 | 独立 JLo 致敬网站", description: "通过独立的多语言时间线，了解詹妮弗·洛佩兹的人生、事业、音乐、电影、风格与文化影响。本站并非官方网站。" },
    timeline: { title: "詹妮弗·洛佩兹时间线 | 独立 JLo 致敬网站", description: "附有来源的詹妮弗·洛佩兹事业与文化影响时间线。独立致敬 — 本站并非官方网站。" },
    music: { title: "詹妮弗·洛佩兹音乐与专辑 | 独立 JLo 致敬网站", description: "精选詹妮弗·洛佩兹音乐生涯的重要时刻。独立致敬 — 本站并非官方网站。" },
    film: { title: "詹妮弗·洛佩兹的电影 | 独立 JLo 致敬网站", description: "精选詹妮弗·洛佩兹电影生涯的重要时刻。独立致敬 — 本站并非官方网站。" },
    style: { title: "詹妮弗·洛佩兹风格与时尚 | 独立 JLo 致敬网站", description: "詹妮弗·洛佩兹在时尚与红毯上的影响。独立致敬 — 本站并非官方网站。" },
    legacy: { title: "詹妮弗·洛佩兹的文化影响与遗产 | 独立 JLo 致敬网站", description: "为何詹妮弗·洛佩兹是其一代具有代表性的艺人。独立致敬 — 本站并非官方网站。" },
    about: { title: "关于本项目 | 独立 JLo 致敬网站", description: "关于这个独立、多语言的詹妮弗·洛佩兹致敬与时间线项目。本站并非官方网站。" },
    disclaimer: { title: "免责声明 | 独立 JLo 致敬网站", description: "独立致敬网站免责声明。与詹妮弗·洛佩兹无任何关联或背书。本站并非官方网站。" },
    contact: { title: "联系我们 | 独立 JLo 致敬网站", description: "联系这个詹妮弗·洛佩兹致敬项目背后的独立团队。本站并非官方网站。" },
    privacy: { title: "隐私政策 | 独立 JLo 致敬网站", description: "这个独立詹妮弗·洛佩兹致敬网站的隐私政策。本站并非官方网站。" },
  },
  ui: {
    skipToContent: "跳到内容",
    exploreTimeline: "浏览时间线",
    officialWebsite: "官方网站",
    officialStore: "官方商店",
    onTheJlo: "On The JLo",
    readMore: "阅读更多",
    readLess: "收起",
    opensNewTab: "（在新标签页中打开）",
    backToTop: "返回顶部",
    selectLanguage: "选择语言",
    language: "语言",
    source: "来源",
    nav: { home: "首页", timeline: "时间线", music: "音乐", film: "电影", style: "风格", legacy: "遗产", about: "关于", disclaimer: "免责声明", contact: "联系", privacy: "隐私" },
  },
  disclaimer: {
    bar: "独立致敬网站 — 与詹妮弗·洛佩兹或其官方团队无关联，也未获其背书。",
    long: "本站是一个独立的致敬与信息网站。它与詹妮弗·洛佩兹、其管理团队、唱片公司、品牌、官方网站或官方商店没有关联、背书、赞助或官方联系。",
  },
  hero: { title: "詹妮弗·洛佩兹：", titleAccent: "从布朗克斯到全球偶像", subtitle: "一个独立的多语言致敬项目，探索詹妮弗·洛佩兹的人生、艺术、事业里程碑与文化影响。" },
  trust: { heading: "一个独立的致敬", body: "本站是一个独立的致敬与信息网站。它与詹妮弗·洛佩兹、其管理团队、厂牌、品牌、官方网站或官方商店没有关联、背书或赞助。如需官方信息，请使用下方的官方链接。" },
  timelineSection: { kicker: "从布朗克斯到世界", heading: "人生与事业时间线", subtitle: "沿着塑造一段全球事业的时刻，进行一次有据可查的时间之旅。" },
  categories: { earlyLife: "早年", music: "音乐", film: "电影", dance: "舞蹈", fashion: "时尚", business: "商业", legacy: "遗产" },
  pillarsSection: { kicker: "事业支柱", heading: "全球事业的六大支柱", subtitle: "她的作品留下印记的创意与文化领域。" },
  pillars: {
    music: { title: "音乐", body: "从舞曲流行的出道到登顶榜单的专辑，音乐二十多年来一直是她事业的核心。" },
    film: { title: "电影", body: "一段扎实的电影事业，涵盖浪漫喜剧、剧情片以及《Hustlers》等广受好评的角色。" },
    dance: { title: "舞蹈", body: "最初以舞者身份接受训练，律动与编舞至今仍是她现场表演的核心。" },
    fashion: { title: "时尚与风格", body: "她在红毯与舞台上的风格，影响了关于时尚与美的更广泛讨论。" },
    business: { title: "商业与品牌", body: "她拓展到香水与生活方式业务，助力塑造了名人品牌模式。" },
    impact: { title: "文化影响", body: "作为最具曝光度的拉丁裔艺人之一，她拓宽了主流流行文化中的代表性。" },
  },
  impactSection: {
    kicker: "全球影响",
    heading: "一道全球性的文化印记",
    subtitle: "一种总体的文化概览 — 刻意避免夸张的数字。",
    points: [
      { title: "拉丁流行文化", body: "助力将拉丁流行的声音与艺人更多地带入全球主流。" },
      { title: "好莱坞中的代表性", body: "提升了拉丁裔演员在主演电影中的曝光度。" },
      { title: "全球音乐榜单", body: "在多张专辑中取得国际榜单的成功。" },
      { title: "时尚与美", body: "影响了红毯与美妆领域中广受讨论的趋势。" },
      { title: "现场表演", body: "以在大型舞台上充满活力、以舞蹈为主的现场演出而闻名。" },
      { title: "多元文化受众", body: "在众多国家建立了广泛、多语言的粉丝群体。" },
    ],
  },
  worksSection: { kicker: "精选作品", heading: "音乐与电影亮点", music: "音乐亮点", film: "电影亮点", whyItMatters: "为何重要" },
  essay: {
    kicker: "评论",
    heading: "为何詹妮弗·洛佩兹成为其一代具有代表性的艺人之一",
    paragraphs: [
      "很少有表演者能像詹妮弗·洛佩兹这样在音乐、电影与舞蹈之间游刃有余。她从纽约的舞者起步，建立了一段拒绝局限于单一领域的事业。",
      "她凭《Selena》声名鹊起，紧接着推出首张专辑，展现出同时引领电影与音乐话题的罕见能力。这种多才多艺成为她的标志。",
      "除了作品本身，她的曝光度同样重要。作为同代最受瞩目的拉丁裔艺人之一，她拓宽了代表性，并帮助塑造了主流流行文化的声音、形象与表演方式。",
    ],
    pullQuote: "从布朗克斯到全球舞台 — 一段建立在多才多艺、自律与不断重塑之上的事业。",
  },
  faqSection: { kicker: "问题", heading: "常见问题" },
  faq: {
    official: { q: "这是詹妮弗·洛佩兹的官方网站吗？", a: "不是。本站是一个独立的致敬与信息网站，与詹妮弗·洛佩兹或其团队没有关联。" },
    "where-website": { q: "詹妮弗·洛佩兹的官方网站在哪里？", a: "请使用“官方网站”按钮访问她的官方网站。" },
    "where-store": { q: "在哪里购买官方的詹妮弗·洛佩兹商品？", a: "请使用“官方商店”按钮。本站不销售任何商品。" },
    affiliated: { q: "本网站与詹妮弗·洛佩兹有关联吗？", a: "没有。不存在任何形式的关联、赞助或背书。" },
    about: { q: "本网站是关于什么的？", a: "它以引用来源的方式，呈现关于詹妮弗·洛佩兹事业与文化影响的多语言时间线与介绍。" },
  },
  officialSection: {
    heading: "詹妮弗·洛佩兹官方链接",
    subtitle: "在寻找官方信息？请使用这些外部链接。",
    websiteDesc: "詹妮弗·洛佩兹的官方网站。",
    storeDesc: "商品官方商店。",
    onthejloDesc: "来自 On The JLo 的官方粉丝更新。",
    note: "官方链接将在新标签页中打开。我们与这些目标网站没有关联。",
  },
  footer: {
    tagline: "一个献给詹妮弗·洛佩兹人生、事业与文化影响的独立多语言致敬。",
    notOfficial: "非官方 · 无关联 · 未背书。不销售任何商品。",
    explore: "探索",
    official: "官方链接",
    legal: "信息",
    copyright: "独立致敬网站。所有商标与名称归各自所有者所有。",
  },
  pages: {
    timeline: { intro: "通过一条附有来源、按时间排列的关键时刻时间线，跟随詹妮弗·洛佩兹从布朗克斯走向全球认可的旅程，涵盖音乐、电影、舞蹈与文化。" },
    music: { intro: "詹妮弗·洛佩兹音乐生涯及精选专辑亮点的概览，从出道到近期发行。" },
    film: { intro: "从《Selena》的突破到近期的主演，精选詹妮弗·洛佩兹电影生涯的亮点。" },
    style: { intro: "詹妮弗·洛佩兹在红毯与舞台上的存在，如何与关于时尚与美的更广泛讨论交汇。" },
    legacy: { intro: "一篇评论，审视詹妮弗·洛佩兹的文化影响，以及她为何被视为其一代具有代表性的艺人。" },
    about: {
      heading: "关于本项目",
      paragraphs: [
        "本项目是一个独立的致敬与文化档案。其目标是以清晰、多语言的形式呈现詹妮弗·洛佩兹的事业、成就与文化影响。",
        "它并非官方网站，与詹妮弗·洛佩兹、其管理团队、厂牌或品牌没有任何联系。如需官方更新，请使用站内的官方链接。",
        "内容基于公开、可靠的来源，仅供信息与教育之用。若您代表权利持有人并希望请求更正，请与我们联系。",
      ],
    },
    disclaimer: {
      heading: "免责声明",
      intro: "请仔细阅读本免责声明。",
      points: [
        "本站并非詹妮弗·洛佩兹的官方网站。",
        "本站与詹妮弗·洛佩兹或其团队无关联，也未获其背书或赞助。",
        "本站不销售任何商品、门票或周边。",
        "无意冒充任何个人或组织。",
        "所有商标、名称及相关权利归各自所有者所有。",
        "官方链接仅为方便访问者而提供。",
        "若您是权利持有人并希望更正、署名或移除内容，请与我们联系。",
      ],
    },
    contact: {
      heading: "联系我们",
      intro: "请使用下面的表单联系这个致敬项目背后的独立团队。",
      rightsHolderNote: "若您代表詹妮弗·洛佩兹、其管理团队或任何权利持有人，并希望对内容进行更正、更新、署名、移除或重定向，请与我们联系。",
      form: { name: "姓名", email: "电子邮箱", reason: "事由", message: "留言", submit: "发送留言", sending: "发送中…", success: "谢谢。您的留言已收到。", error: "出现问题。请重试。" },
      reasons: { correction_request: "更正请求", translation_issue: "翻译问题", copyright_trademark_concern: "版权 / 商标顾虑", general_feedback: "一般反馈" },
    },
    privacy: {
      heading: "隐私政策",
      paragraphs: [
        "本独立致敬网站尊重您的隐私。我们仅收集您选择提供的信息，例如通过联系表单提交的内容。",
        "若启用分析功能，可能会收集匿名使用数据以了解网站的使用情况。在网站所有者配置密钥之前，不会运行任何分析。",
        "联系表单数据仅用于回复您的留言，不会出于营销目的出售或共享。",
        "使用本站即表示您同意本政策。如有疑问，请使用联系页面。",
      ],
    },
    notFound: { heading: "页面未找到", body: "您查找的页面不存在或已被移动。", cta: "返回首页" },
  },
  timeline: {
    "birth-1969": { title: "出生于布朗克斯", summary: "詹妮弗·林恩·洛佩兹于1969年7月24日出生在纽约布朗克斯，父母为波多黎各人。", details: "她在一个波多黎各工薪家庭长大，从小就浸润于音乐与舞蹈之中。" },
    "bronx-1970s": { title: "在纽约成长", summary: "她在布朗克斯度过童年，幼时便学习歌唱与舞蹈。", details: "在纽约早期接触表演，塑造了定义其日后事业的自律。" },
    "dance-1980s": { title: "舞者训练", summary: "青少年时期她投身舞蹈，在地区演出与音乐录影带中表演。", details: "她认真追求舞蹈，担任伴舞与舞台表演者。" },
    "living-color-1991": { title: "In Living Color “Fly Girl”", summary: "她作为电视节目《In Living Color》的“Fly Girl”舞者获得全国关注。", details: "这一角色为她带来首次持续的电视曝光与通往娱乐业的道路。" },
    "acting-start-1995": { title: "早期演艺角色", summary: "她凭《Mi Familia》《Money Train》等影片转向表演。", details: "这些早期角色让她成为好莱坞的一颗新星。" },
    "selena-1997": { title: "凭《Selena》突破", summary: "她饰演特哈诺歌手塞莱娜·昆塔尼利亚，这一突破广受赞誉。", details: "主演让她成为当时最受瞩目的拉丁裔演员之一。" },
    "out-of-sight-1998": { title: "Out of Sight", summary: "她在史蒂文·索德伯格广受好评的犯罪片中与乔治·克鲁尼联袂主演。", details: "这次表演巩固了她作为严肃电影演员的声誉。" },
    "on-the-6-1999": { title: "首张专辑《On the 6》", summary: "她的首张专辑《On the 6》开启音乐事业，专辑名取自布朗克斯的一条地铁线。", details: "《If You Had My Love》等单曲确立了她流行与舞曲艺人的地位。" },
    "jlo-album-2001": { title: "《J.Lo》与全球品牌", summary: "专辑《J.Lo》及“J.Lo”形象标志着她崛起为跨领域的全球品牌。", details: "她以同时登顶电影与音乐榜单而闻名。" },
    "wedding-planner-2001": { title: "The Wedding Planner", summary: "她的浪漫喜剧主演，帮助定义了该类型的一个流行时代。", details: "这部影片巩固了她作为票房号召力的地位。" },
    "this-is-me-then-2002": { title: "《This Is Me... Then》", summary: "专辑收录热门单曲《Jenny from the Block》，强调她的布朗克斯根源。", details: "它成为她最具个人色彩、最具辨识度的唱片之一。" },
    "maid-in-manhattan-2002": { title: "Maid in Manhattan", summary: "一部巩固其主流电影明星地位的浪漫喜剧大获成功。", details: "这一角色凸显了她广泛的商业号召力。" },
    "brand-fragrance-2005": { title: "香水与商业", summary: "她拓展到香水与生活方式品牌，建立起持久的商业版图。", details: "她的业务有助于开创美妆领域的名人品牌模式。" },
    "american-idol-2011": { title: "American Idol 评委", summary: "她以评委身份加入《American Idol》，触达庞大的电视观众。", details: "这一角色拓宽了她在美国的主流曝光度。" },
    "aka-2014": { title: "专辑《A.K.A.》", summary: "她在继续平衡音乐、电影与电视的同时发行了《A.K.A.》。", details: "这张唱片反映了她作为录音艺人的持续演进。" },
    "hustlers-2019": { title: "《Hustlers》获赞", summary: "她在《Hustlers》中的角色赢得演艺生涯中一些最强烈的好评。", details: "这次表演广受赞誉，并重新点燃了颁奖季的讨论。" },
    "super-bowl-2020": { title: "超级碗中场秀", summary: "她与夏奇拉共同担纲超级碗 LIV 中场秀。", details: "这场演出在全球观众面前颂扬了拉丁文化。" },
    "marry-me-2022": { title: "《Marry Me》", summary: "她主演并监制了音乐浪漫喜剧《Marry Me》。", details: "该项目将她的音乐与电影工作结合于一次发行之中。" },
    "this-is-me-now-2024": { title: "《This Is Me... Now》", summary: "她发行了与2002年专辑相呼应的《This Is Me... Now》，并带有电影部分。", details: "该项目重新探讨了她事业早期的主题。" },
    "atlas-2024": { title: "《Atlas》", summary: "她主演并监制了科幻电影《Atlas》。", details: "这一角色延续了她作为主演与制片人的工作。" },
  },
  discography: {
    "on-the-6": { title: "On the 6", why: "她的出道作确立了她作为可信的流行与舞曲艺人的地位。" },
    jlo: { title: "J.Lo", why: "巩固了她崛起为跨领域全球品牌的进程。" },
    "this-is-me-then": { title: "This Is Me... Then", why: "其单曲《Jenny from the Block》将她的名气与布朗克斯根源相连。" },
    love: { title: "Love?", why: "标志着一次由舞池单曲驱动的流行回归。" },
    aka: { title: "A.K.A.", why: "展现了她作为录音艺人的持续演进。" },
    "this-is-me-now": { title: "This Is Me... Now", why: "二十年后发行的一部具有反思意味的呼应之作。" },
  },
  filmography: {
    selena: { title: "Selena", why: "宣告她成为重要银幕人才的突破性主演。" },
    "out-of-sight": { title: "Out of Sight", why: "证明其戏剧张力的评论赞誉。" },
    "the-wedding-planner": { title: "The Wedding Planner", why: "帮助定义了浪漫喜剧的一个流行时代。" },
    "maid-in-manhattan": { title: "Maid in Manhattan", why: "一部巩固其主流明星地位的票房热门。" },
    "monster-in-law": { title: "Monster-in-Law", why: "与资深搭档合作的商业喜剧成功之作。" },
    hustlers: { title: "Hustlers", why: "被广泛视为其生涯最佳表演之一。" },
    "marry-me": { title: "Marry Me", why: "融合了她的音乐与电影身份。" },
    "the-mother": { title: "The Mother", why: "在大型流媒体平台上的一个主演动作角色。" },
    atlas: { title: "Atlas", why: "一部体现其制片抱负的科幻主演作品。" },
  },
};

export default zh;
